import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static get targets() {
        return ["bookingField"];
    }

    configureBookingFormForType({ target }) {
        const isSelfBookingType = target.options[target.selectedIndex].value === "self";
        this.bookingFieldTargets.forEach(bft => {
            bft.value = isSelfBookingType && bft.dataset.selfValue || "";
        });
    }
}